'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = exports.Header = exports.Aside = exports.Nav = exports.Article = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  min-height: 550px;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-flow: row;\n\n  @media all and (max-width: 640px) {\n    flex-direction: column;\n  }\n'], ['\n  min-height: 550px;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-flow: row;\n\n  @media all and (max-width: 640px) {\n    flex-direction: column;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 5px;\n  background: ', ';\n  flex: 3 1 60%;\n  order: 2;\n\n  @media all and (max-width: 640px) {\n    order: 0;\n  }\n'], ['\n  padding: 5px;\n  background: ', ';\n  flex: 3 1 60%;\n  order: 2;\n\n  @media all and (max-width: 640px) {\n    order: 0;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  border-right: 16px ', ' solid;\n  background: ', ';\n  order: 1;\n  ', ';\n\n  transition: flex-basis 500ms ease-in-out;\n\n  @media all and (max-width: 640px) {\n    order: 0;\n    border-top: 16px #342 solid;\n    border-right: 0px;\n  }\n'], ['\n  border-right: 16px ', ' solid;\n  background: ', ';\n  order: 1;\n  ', ';\n\n  transition: flex-basis 500ms ease-in-out;\n\n  @media all and (max-width: 640px) {\n    order: 0;\n    border-top: 16px #342 solid;\n    border-right: 0px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  padding: 5px;\n  background: ', ';\n  flex: 1 6 20%;\n  order: 3;\n\n  @media all and (max-width: 640px) {\n    order: 0;\n    min-height: 50px;\n    max-height: 50px;\n  }\n'], ['\n  padding: 5px;\n  background: ', ';\n  flex: 1 6 20%;\n  order: 3;\n\n  @media all and (max-width: 640px) {\n    order: 0;\n    min-height: 50px;\n    max-height: 50px;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: block;\n  padding: 5px;\n  min-height: 40px;\n  background: ', ';\n'], ['\n  display: block;\n  padding: 5px;\n  min-height: 40px;\n  background: ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  background: ', ';\n'], ['\n  background: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LayoutAdmin = _styledComponents2.default.div(_templateObject);

var Article = exports.Article = _styledComponents2.default.article(_templateObject2, function (props) {
  return props.theme.bahLayoutArticleBackgroundColor;
});

var Nav = exports.Nav = _styledComponents2.default.nav(_templateObject3, function (props) {
  return props.theme.bahLayoutNavBoderRightColor;
}, function (props) {
  return props.theme.bahLayoutNavBackgroundColor;
}, function (props) {
  return props.bahHidden ? 'flex: 0 6 0;\n        overflow: hidden;\n        &:hover {\n          flex-basis: 10em;\n        }\n      ' : 'flex: 0 6 ' + props.theme.bahNavDefaultFlexBasis + ';';
});

var Aside = exports.Aside = _styledComponents2.default.aside(_templateObject4, function (props) {
  return props.theme.bahLayoutAsideBackgroundColor;
});

var Header = exports.Header = _styledComponents2.default.div(_templateObject5, function (props) {
  return props.theme.bahLayoutHeaderBackgroundColor;
});

var Footer = exports.Footer = Header.extend(_templateObject6, function (props) {
  return props.theme.bahLayoutFooterBackgroundColor;
});

exports.default = LayoutAdmin;


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/LayoutAdmin.js
// module id = 104
// module chunks = 0